export default "__VITE_ASSET__CQFeoTMy__"